export const styles = {
  deleteButton: {
    marginRight: "auto",
    color: "warning.dark",
    "&:hover": {
      bgcolor: "warning.light",
    },
  },
  button: {
    color: "secondary.dark",
    "&:hover": {
      bgcolor: "secondary.light",
    },
  },
};
